export default __webpack_public_path__ + "static/media/fishery_2.6aaeafc8.jpg";